import httpStore from "@/api/httpStore.js";

export function getStoreSellers() {
  return httpStore
    .get("/sellers")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
